<template>
    <div>
        <div class="listGallery" :id="'gallery_'+idBooth">
            <img 
                v-for="(imgName, index) in arrayToDisplay" 
                :key="index" 
                :index="index" 
                class="thumbnailList" 
                :id="'illus'+idBooth+'_'+index" 
                :src="`https://preprod.api.defipix.fr/booth/image/${idBooth}/${imgName}`" 
                :alt="'Illustration de la Défipix'"
                @click="displayImage(imgName)">
        </div>
        <div v-if="imageArray.length > 9" class="buttonBar">
            <img class="arrow" :src="'https://preprod.api.defipix.fr/logos/prev_200.png'" alt="previous step" @click="prevPage" />
            <span class="counter">{{ page + 1 }} / {{ Math.ceil(imageArray.length/9) }}</span>
            <img class="arrow" :src="'https://preprod.api.defipix.fr/logos/next_200.png'" alt="next step" @click="nextPage" />
        </div>
        <div v-if="diaporama" class="diaporama">
            <div class="diapoContent">
                <div class="closeContainer">
                    <img class="closeBtn" :src="'https://preprod.api.defipix.fr/logos/close_200_pink.png'" alt="next step" @click="toggleDiaporama" />
                </div>
                <img class="diaporamaImage" :src="`https://preprod.api.defipix.fr/booth/image/${idBooth}/${imageSelected}`"  alt="view of diaporama" @click="toggleDiaporama" />
                <div class="buttonBar">
                    <img class="arrow" :src="'https://preprod.api.defipix.fr/logos/prev_200.png'" alt="previous step" @click="prevImage" />
                    <span class="counter black">{{ imageArray.indexOf(imageSelected) + 1}} / {{ imageArray.length }}</span>
                    <img class="arrow" :src="'https://preprod.api.defipix.fr/logos/next_200.png'" alt="next step" @click="nextImage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JQuery from 'jquery';
let $ = JQuery;

export default {
    data() {
        return {
            arrayToDisplay: [],
            page: 0,
            diaporama: false,
            imageSelected: null,
        }
    },
    mounted: function () {
        for (let i = 0; i < 9; i++) {
            if(this.imageArray[i]) {
                this.arrayToDisplay.push(this.imageArray[i]);
            }
        }

        document.addEventListener('keydown', (event) => {
            if (event.keyCode === 27 && this.diaporama) {
                this.toggleDiaporama();
            }
            if (event.keyCode === 39 && this.diaporama) {
                this.nextImage();
            }
            if (event.keyCode === 37 && this.diaporama) {
                this.prevImage();
            }
        }, false);
    },
    methods: {
        nextPage() {
            if ((this.page+1)*9 > this.imageArray.length) return;
            this.arrayToDisplay = [];
            for (let i = (this.page+1)*9; i < (this.page+1)*9+9; i++) {
                if(this.imageArray[i]) {
                    this.arrayToDisplay.push(this.imageArray[i]);
                }
            };
            this.page++;
        },
        prevPage() {
            if (this.page === 0 ) return;
            this.arrayToDisplay = [];
            for (let i = (this.page-1)*9; i < (this.page-1)*9+9; i++) {
                if(this.imageArray[i]) {
                    this.arrayToDisplay.push(this.imageArray[i]);
                }
            };
            this.page--;
        },
        displayImage(name) {
            this.imageSelected = name;
            this.toggleDiaporama();
        },
        toggleDiaporama() {
            this.diaporama = !this.diaporama;
        },
        nextImage() {
            if (this.imageArray.indexOf(this.imageSelected) + 1 === this.imageArray.length) return;
            let positonNext = this.imageArray.indexOf(this.imageSelected) + 1;
            this.imageSelected = this.imageArray[positonNext];
        },
        prevImage() {
            if (this.imageArray.indexOf(this.imageSelected) === 0) return;
            let positonNext = this.imageArray.indexOf(this.imageSelected) - 1;
            this.imageSelected = this.imageArray[positonNext];
        }
    },
    props: {
        imageArray: Array,
        idBooth: Number,
    }
}

</script>

<style scoped>

.gallery {
    display: flex;
    flex-direction: row;
    margin: 0.5em;
}

.listGallery {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 10em;
    overflow-x: auto;
    overflow-y: hidden;
    padding: .5em 0;
}

.thumbnailList {
    height: 100%;
    margin: 1em;
    border: 2px solid#0070cd;
    border-radius: 5px;
}

.thumbnailList:hover {
    cursor: pointer;
    transform: scale(1.02);
}

.buttonBar {
    display: flex;
    justify-content: center;
}

.counter {
    color: #fff;
    font-weight: 700;
}

.arrow {
    width: 2em;
    height: 2em;
    margin: 0 1em;
}

.arrow:hover, .thumbnail:hover, .closeBtn:hover {
    cursor: pointer;
    transform: scale(1.1);
}

.diaporama {
    position: fixed;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: rgba(112, 112, 112, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.diapoContent {
    background-color: #fff;
    padding: 1em;
    border-radius: 5px;
}

.closeContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.closeBtn {
    color: #f677c4;
    width: 1.5em;
    height: 1.5em;
}

.diaporamaImage {
    display: block;
    max-width: 80vw;
    max-height: 80vh;
    margin: 1em auto;
    border: 1px solid rgb(245, 245, 245);
}

.black {
    color: #000;
}

</style>


// WEBPACK FOOTER //
// src/components/Booths/Gallery.vue